module.exports = __webpack_public_path__ + "media/vue/assets/images/account/beauty_pass/hero_web-aa912bb5e2dbf81b88908b3503ae064c.jpg";